<template>
  <div class="inventory-dashboard">
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4">Inventory Dashboard</h1>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn color="primary" v-if="currentUser.privileges.canManageInventorySettings" rounded outlined small class="my-2" id="inventory_settings" :to="{name: 'InventorySettings'}">Inventory Settings</v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-2">
        <v-col cols="6" md="3">
            <v-hover v-slot="{ hover }">
            <v-card 
                tile :to="{ name: 'InventoryItems' }" 
                :elevation="hover ? 5 : 2"
                :class="{ 'on-hover': hover }"
            >
                <v-card-title>
                    <h3>{{ dashboard_counts.items_in_stock || 0 }}</h3>
                </v-card-title>
                <v-card-text class="text-left black--text">
                    <h4>Total Items In Stock</h4>
                </v-card-text>
            </v-card>
            </v-hover>
        </v-col>
        <v-col cols="6" md="3">
            <v-hover v-slot="{hover}">
            <v-card tile 
                :to="{ name:'PurchaseOrders' }"
                :elevation="hover? 5 : 2"
                :class="{ 'on-hover': hover }"
            >
                <v-card-title>
                    <h3>{{ dashboard_counts.purchase_orders }}</h3>
                </v-card-title>
                <v-card-text class="text-left black--text">
                    <h4>Purchase orders</h4>
                </v-card-text>
            </v-card>
            </v-hover>
        </v-col>
        <v-col cols="6" md="3">
            <v-hover v-slot="{hover}">
            <v-card tile 
                :to="{ name: 'Suppliers' }"
                :elevation="hover? 5 : 2"
                :class="{ 'on-hover': hover }"
            >
                <v-card-title>
                    <h3>{{ dashboard_counts.suppliers }}</h3>
                </v-card-title>
                <v-card-text class="text-left black--text">
                    <h4>Suppliers</h4>
                </v-card-text>
            </v-card>
            </v-hover>
        </v-col>
        <v-col cols="6" md="3">
            <v-hover v-slot="{hover}">
            <v-card tile 
                :to="{ name: 'GRNs' }"
                :elevation="hover? 5 : 2"
                :class="{ 'on-hover': hover }"
            >
                <v-card-title>
                    <h3>{{ dashboard_counts.grns }}</h3>
                </v-card-title>
                <v-card-text class="text-left black--text">
                    <h4>GRNs</h4>
                </v-card-text>
            </v-card>
            </v-hover>
        </v-col>
    </v-row>
    <div v-if="currentUser.privileges.canViewAllStores" class="inventory-dashboard-stores">

    <v-row>
        <v-col cols="7" md="8">
            <h2 class="text-left mx-4">Stores</h2>
        </v-col>
        <v-col cols="5" md="4">
            <v-btn v-if="currentUser.privileges.canAddStores" color="primary" id="add-store" rounded small :to="{name: 'AddStore'}">Add Store</v-btn>
        </v-col>
    </v-row>
    
    <v-row class="mx-2">
        <v-col cols="12" md="3" v-for="store in stores" :key="store.id">
            <v-hover v-slot="{ hover }">
            <v-card :to="{ name: 'StoreDetails', params: { store_id: store.id } }"
                :elevation="hover? 5 : 2"
                :class="{ 'on-hover': hover }"
            >
                <v-card-title>{{ store.store_name }}</v-card-title>
                <v-card-subtitle v-if="store.store_items" class="text-left">{{ store.store_items.map(item => item.item_name ).slice(0,3).join(", ") }}</v-card-subtitle>
                <v-card-subtitle v-else class="text-left">No items added</v-card-subtitle>  
            </v-card>
            </v-hover>
        </v-col>
    </v-row>
    </div>

<!-- 
        <v-card class="mx-4 my-4" v-if="currentUser.privileges.canViewAllPurchaseOrders">
            <v-card-title>
              Pending Purchase Orders
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title> -->
             <!-- filter -->
              <!-- <v-row class="mx-4">
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.category"
                    :items="categories"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Category"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="code"
                    item-text="code"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.room"
                    :items="rooms"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Classroom"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="id"
                    item-text="sections"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.status"
                    :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Payment Status"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>
              </v-row> -->


              <!-- filter end -->
            <!-- <v-data-table
              :headers="pruchase_orders_headers"
              :items="pruchase_orders"
              :items-per-page="15"
              id="purchase-order-table"
              class="row-pointer"
              @click:row="clickPurchaseOrderRow"
            >
                <template v-slot:item.created="{item}">
                    {{ moment(item.created).format("DD MMM, YYYY") }}
                </template>

                <template v-slot:item.total_amount="{ item }">
                    {{ currencyFormat(item.total_amount) }}
                </template>
            </v-data-table>
        </v-card> -->
         <IntractDataTable
            title="Pending Purchase Orders"
            :headers="purchase_orders_headers"
            :endpoint="endpointUrl"
            :export-fields="export_fields"
            :filter-fields="filterFields"
            search-parameter="query"
            order-parameter="o"
            :can-export="currentUser.privileges.canExportFeeAccounts"
            id="inventory-items-table"
            @handleClick="clickPurchaseOrderRow"
            >
                <template v-slot:item.created="{ item }">
          {{ moment(item.created).format("DD MMM, YYYY") }}
        </template>

        <template v-slot:item.total_amount="{ item }">
          {{ currencyFormat(item.total_amount) }}
        </template>

        <template v-slot:item.quantity="{ item }">
          {{item.store_item.usage_unit ? item.quantity + " (" + item.store_item.usage_unit + ")" : item.quantity}}
        </template>
            </IntractDataTable>
    
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import endpoints from "@api/repository";
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Helper from "@utils/misc";
import TourHelper from "@utils/tour_helper";
import IntractDataTable from "@components/widgets/generics/IntractDataTable";

export default {
    name: 'InventoryDashboard',
    data(){
        return{
            snackbar: {
                visible: false,
                text: "",
            },
            moment: moment,
            search: "",
            options:{},
            pagination: {
                totalCount: 0,
                url: endpoints.purchaseOrders + "?status=1", 
            },
            dashboard_counts: {
                items_in_stock : 0,
                purchase_orders : 0,
                suppliers: 0,
                grns: 0,
                
            },
            purchase_orders_headers:[
                { text: "Order No", value: "order_number", align: "center", sortable: false },
                { text: "Item Code", value: "store_item.code", align: "center", sortable: false },
                { text: "Item Name", value: "store_item.item_name", sortable: false },
                { text: "Order Date", value: "created", align: "center", sortable: true },
                { text: "Supplier", value: "supplier.supplier_name", align: "center", sortable: false },
                { text: "Store", value: "store_item.store.store_name", align: "center", sortable: false },
                { text: "Quantity", value: "quantity", align: "center", sortable: true },
                { text: "Total Amount", value: "total_amount", align: "center", sortable: false },       
            ],
            export_fields: {
                "Order No.": "order_number",
                "Item Code": "item_code",
                "Item Name": "item_name",
                "Order Date": "order_date",
                "Supplier": "supplier",
                "Store": "store",
                "Quantity": "quantity",
                "Total Amount": "total_amount",
                "Status": "status",
            },
            filterFields: {
                supplier: {
                model: null,
                items: [],
                label: "Filter by Supplier",
                itemValue: "id",
                itemText: "supplier_name",
                param: "supplier_id",
                endpoint: endpoints.suppliers,
                },
                store: {
                model: null,
                items: [],
                label: "Filter by Store",
                itemValue: "id",
                itemText: "store_name",
                param: "store_id",
                endpoint: endpoints.stores,
                },
                storeItem: {
                model: null,
                items: [],
                label: "Filter by Store Item",
                itemValue: "id",
                itemText: "item_name",
                param: "store_item_id",
                endpoint: Helper.addUrlParams(endpoints.storeItem, ['count=true']),
                },
            },
            pruchase_orders : [],
            stores: [
                // {
                //     id: 1,
                //     store_name: 'Stationary eg.',
                //     store_items : ['Chalks','Dusters', 'Markers']
                // }
            ]
        }
    },
    components: {
        // downloadExcel: JsonExcel,
        IntractDataTable
    },
    computed: {
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
        endpointUrl() {        
            return Helper.addUrlParams(endpoints.purchaseOrders, ['status=1']);
        }
    },
    methods: {
        ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', title: "Welcome to Inventory Section!", description: "Let's start with a quick tour!", videoLink: "https://youtube.com"});
      steps.push({id: '2', title: "Inventory Settings", description: "Check your inventory settings, where you can access store type, category and supplier type", el: '#inventory_settings'});
      steps.push({id: '3', title: "Add Store", description: "Add your new store entry", el: '#add-store'});
      steps.push({id: '4', description: "View all your purchase orders and click on a row for individual order details.", el: '#purchase-order-table',position:'top'});


      TourHelper.startTour(this, "inventory__dashboard", steps);
    },


        async getAllStores(){
            this.stores = await api.call(this.essentials, endpoints.stores);
        },
        // handles api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        clickPurchaseOrderRow(value){
            this.$router.push({ name: 'PurchaseOrderDetails', params: { po_id: value.id }})
        },

        async getPendingPurchaseOrders(){
            var response;
            var url = this.pagination.url;
            if(this.search){
                url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
            }
            response = await api.call(this.essentials,url);

            if(response){
                this.pruchase_orders = response.results;
                this.pagination.totalCount = response.count;
                this.pagination.nextUrl = response.next;
            }
        },

        async getInventoryDashboardBoardCounts(){
            var response = await api.call(this.essentials, endpoints.getInventoryDashboardCounts)
            if(response){
                this.dashboard_counts = response;
            }
        },

        currencyFormat(amount){
            return Helper.currencyFormat(amount);
        }
    },
    watch: {
        search: {
            async handler() {
                this.options.page = 1;
                var searched = this.search;
                var self = this;
                setTimeout(function () {
                    if (searched == self.search) {
                        self.getPendingPurchaseOrders();
                    }
                }, 500);
            },
        }
    },
    created(){
        this.handleTour();
        this.getInventoryDashboardBoardCounts();
        this.getAllStores();
        this.getPendingPurchaseOrders();
    }

}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
